export const NEWS = [
  {
    title: "Introducing ether.fi Ventures",
    date: "2025",
    cat: "Insights",
    url: "https://medium.com/@ether.fi_Ventures/ether-fi-ventures-a-new-chapter-at-cryptos-frontier-9c167a315073",
  },
  {
    title: "Hyperbeat Secures $5.2M Seed Round",
    date: "2025",
    cat: "Portfolio News",
    url: "https://www.coindesk.com/tech/2025/08/15/hyperbeat-secures-usd5-2m-backing-from-ether-fi-electric-capital",
  },
];
